module.exports = __webpack_public_path__ + "img/parter-avatar13.69e6c8e4.png";